import { Navigate, Route, Routes } from 'react-router-dom'
import NewSecretsPage from './pages/NewSecretsPage'
import ValidateSecretsPage from './pages/ValidateSecretsPage'
import AuditPage from './pages/AuditPage'

const KeyVaultRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/key-vault/new-secrets" replace />} />
      <Route path="/new-secrets" element={<NewSecretsPage />} />
      <Route path="/validate-secrets" element={<ValidateSecretsPage />} />
      <Route path="/audit" element={<AuditPage />} />
      <Route path="*" element={<Navigate to="/key-vault/new-secrets" replace />} />
    </Routes>
  )
}

export default KeyVaultRoutes
